import React, { useState, useEffect } from "react";
import { Box, Typography, TextField } from "@mui/material";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";

const EstudianteNotas = () => {
  const [inscripciones, setInscripciones] = useState([]);
  const [notas, setNotas] = useState([]);
  const [carreraSeleccionada, setCarreraSeleccionada] = useState("");

  const storedUser = JSON.parse(sessionStorage.getItem("user"));
  const userId = storedUser?.id;

  useEffect(() => {
    if (!userId) return;

    axios
      .get(`${process.env.REACT_APP_API_URL}/estudiantes/${userId}/inscripciones`)
      .then((res) => {
        const inscs = res.data.data || res.data;
        setInscripciones(inscs);
        if (inscs.length > 0) setCarreraSeleccionada(inscs[0].carrera_id.toString());
      });
  }, [userId]);

  useEffect(() => {
    if (!userId || !carreraSeleccionada) return;

    axios
      .get(`${process.env.REACT_APP_API_URL}/estudiantes/${userId}/notas`, {
        params: { carrera_id: carreraSeleccionada },
      })
      .then((res) => {
        // 🔍 EL CAMBIO ESTÁ AQUÍ: Antes tenías setNotas(res.data)
        // Como el backend ahora responde con { error: false, data: [...] }, debemos acceder a .data
        const notasData = res.data.data || res.data; 
        setNotas(Array.isArray(notasData) ? notasData : []);
      })
      .catch((err) => {
        console.error("Error cargando notas:", err);
        setNotas([]); // Evita que se rompa si falla
      });
  }, [userId, carreraSeleccionada]);

  const maxEvaluaciones = notas.reduce((max, nota) => {
    const len = nota.detalle_notas?.length || 0;
    return len > max ? len : max;
  }, 0);

  const columns = [
    { Header: "Materia", accessor: "materia" },
  ];

  for (let i = 0; i < maxEvaluaciones; i++) {
    columns.push(
      { Header: `P${i + 1}`, accessor: `p${i + 1}` },
      { Header: `T${i + 1}`, accessor: `t${i + 1}` },
      { Header: `NF${i + 1}`, accessor: `nf${i + 1}` }
    );
  }

  columns.push({ Header: "Promedio", accessor: "promedio" });

  const rows = notas.map((nota) => {
    const row = { materia: nota.materia };
    const nfList = [];
    (nota.detalle_notas || []).forEach((d, index) => {
      row[`p${index + 1}`] = d.practico;
      row[`t${index + 1}`] = d.teorico;
      row[`nf${index + 1}`] = d.nota_total;
      nfList.push(Number(d.nota_total));
    });
    row.promedio =
      nfList.length > 0
        ? (nfList.reduce((sum, n) => sum + n, 0) / nfList.length).toFixed(2)
        : "-";
    return row;
  });

  return (
    <Box p={3} position="relative" overflow="hidden">

      <Box
        bgcolor="#fff3e0"
        color="#e65100"
        p={2}
        mb={3}
        borderRadius={2}
        textAlign="center"
        border="1px solid #ffe0b2"
      >
        <Typography variant="subtitle1" fontWeight="bold">
          ⚠️ DOCUMENTO NO VÁLIDO PARA TRÁMITES OFICIALES ⚠️
        </Typography>
        <Typography variant="body2">
          Esta visualización es solo para fines informativos del estudiante.
        </Typography>
      </Box>

      <Typography variant="h5" mb={2}>
        Mis Notas
      </Typography>

      <TextField
        select
        label="Seleccione Carrera o Capacitación" // Cambiado para que sea más intuitivo
        fullWidth
        margin="normal"
        value={carreraSeleccionada}
        onChange={(e) => setCarreraSeleccionada(e.target.value)}
        SelectProps={{ native: true }}
      >
        <option value=""></option>
        {inscripciones.map((insc) => (
          <option key={insc.carrera_id} value={insc.carrera_id.toString()}>
            {insc.nombre_carrera}
          </option>
        ))}
      </TextField>

      <Box mt={3} position="relative"> 
        <Box
          position="absolute"
          top="50%"
          left="50%"
          style={{
            transform: "translate(-50%, -50%) rotate(-30deg)", 
            zIndex: 0,
            whiteSpace: "nowrap",
          }}
          sx={{
            userSelect: "none", 
            pointerEvents: "none", 
          }}
        >
          <Typography
            variant="h1"
            component="div"
            sx={{
              color: "rgba(0, 0, 0, 0.06)", 
              fontWeight: "bold",
              fontSize: "6rem", 
              textTransform: "uppercase",
              letterSpacing: "0.5rem",
            }}
          >
            No Válido
          </Typography>
        </Box>

        <DataTable
          table={{ columns, rows }}
          canSearch={false}
          entriesPerPage={true}
          isSorted={false}
        />
      </Box>
    </Box>
  );
};

export default EstudianteNotas;